/**
 * WEBPACK_CONIFG_HOST的值，在webpack.config.js中更改
 * 开发环境时 = "http://amptest.wisedu.com/xsfwfw/"
 * 发布环境时 = location.origin + location.pathname.substring(0, location.pathname.indexOf("/", 1)) + "/"
 */
// console.log("process.env",process.env)
export default {
  login: process.env.WEBPACK_CONFIG_HOST + '/WebService.asmx/UserLogin',
  UserAdd: process.env.WEBPACK_CONFIG_HOST + '/WebService.asmx/UserAdd',
  UserPasswordSet: process.env.WEBPACK_CONFIG_HOST + '/WebService.asmx/UserPasswordSet',
  CmsList: process.env.WEBPACK_CONFIG_HOST + '/WebService.asmx/CmsList',
  FruitList: process.env.WEBPACK_CONFIG_HOST + '/WebService.asmx/FruitList',
  FruitPolyphenolList: process.env.WEBPACK_CONFIG_HOST + '/WebService.asmx/FruitPolyphenolList',
  FruitPolyphenolField: process.env.WEBPACK_CONFIG_HOST + '/WebService.asmx/FruitPolyphenolField',
  OpinionAdd: process.env.WEBPACK_CONFIG_HOST + '/WebService.asmx/OpinionAdd',
  FruitNameList: process.env.WEBPACK_CONFIG_HOST + '/WebService.asmx/FruitNameList',
  FruitTypeList: process.env.WEBPACK_CONFIG_HOST + '/WebService.asmx/FruitTypeList',
  emailPost: 'http://121.196.192.110:8099/public/app/sendEmail',
  FruitDetails: process.env.WEBPACK_CONFIG_HOST + '/WebService.asmx/FruitDetails',
  ProvinceList: process.env.WEBPACK_CONFIG_HOST + '/WebService.asmx/ProvinceList',

  KeywordsList: process.env.WEBPACK_CONFIG_HOST + '/WebService.asmx/KeywordsList',
  SMSPost: process.env.WEBPACK_CONFIG_HOST + '/WebService.asmx/SMSPost',

  // getWechatSign: WEBPACK_CONFIG_HOST + 'app/getWechatSign',
  // login: WEBPACK_CONFIG_HOST + 'app/login', //post
  // updatepassword: WEBPACK_CONFIG_HOST + 'app/updatepassword', //post
  // getServicePhone: WEBPACK_CONFIG_HOST + 'app/getServicePhone',
  // getUserInfo: WEBPACK_CONFIG_HOST + 'app/getUserInfo',
  // driverInfo: WEBPACK_CONFIG_HOST + 'app/oiluser/driverInfo',
  // getQrCode: WEBPACK_CONFIG_HOST + 'app/getQrCode',
  // oilorderList: WEBPACK_CONFIG_HOST + 'app/oilorder/list',
  // oilorderInfo: WEBPACK_CONFIG_HOST + 'app/oilorder/info',
  // oilorderSave: WEBPACK_CONFIG_HOST + 'app/oilorder/save', //post
  // driverRechargeRecordList: WEBPACK_CONFIG_HOST + 'app/oilpaydriver/driverRechargeRecordList',
  // oilstationList: WEBPACK_CONFIG_HOST + 'app/oilstation/list',
  // userOilStationlist: WEBPACK_CONFIG_HOST + 'app/oilstation/userOilStationlist',
  // oilstationproductList: WEBPACK_CONFIG_HOST + 'app/oilstationproduct/list',

}



// WEBPACK FOOTER //
// ./src/api/api.js